import { render, staticRenderFns } from "./DropdownAction.vue?vue&type=template&id=22308b2a&scoped=true&"
import script from "./DropdownAction.vue?vue&type=script&lang=js&"
export * from "./DropdownAction.vue?vue&type=script&lang=js&"
import style0 from "./DropdownAction.vue?vue&type=style&index=0&id=22308b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22308b2a",
  null
  
)

export default component.exports